import Swal from "sweetalert2";
import { t } from "i18next";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";

const handleError = (body, dispatch) => {
  if (body.code === "bak-error-001") {
    Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");
    return;
  }
  if (body.code === "bak-aut-tok-inv-001" || body.code === "bak-aut-tok-inv-002") {
    Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
    dispatch(startLogout());
    return;
  }
  if (body?.msg) {
    Swal.fire(t("titles.error"), body.msg, "error");
  }
};

const toQuery = (filters = {}) => {
  const query = new URLSearchParams(
    Object.entries(filters).filter(([, value]) => value !== '' && value !== null && value !== undefined)
  ).toString();
  return query;
};

export const startLoadingFlowCmiDashboard = () => {
  return async (dispatch) => {
    dispatch({ type: types.FLOW_CMI_SET_LOADING, payload: true });
    try {
      const resp = await fetchToken(const_routes.SCHEMA, const_routes.VERSIONV1, const_routes.ROUTE_FLOW_CMI, 'dashboard');
      const body = await resp.json();
      if (body.ok) {
        dispatch({ type: types.FLOW_CMI_SET_DASHBOARD, payload: body.dashboard || {} });
      } else {
        handleError(body, dispatch);
      }
    } finally {
      dispatch({ type: types.FLOW_CMI_SET_LOADING, payload: false });
    }
  };
};

export const fetchFlowCmiCasesRequest = async (filters = {}) => {
  const query = toQuery(filters);
  const suffix = query ? `search?${query}` : 'search';
  const resp = await fetchToken(const_routes.SCHEMA, const_routes.VERSIONV1, const_routes.ROUTE_FLOW_CMI, suffix);
  return resp.json();
};

export const startSearchingFlowCmiCases = (filters = {}) => {
  return async (dispatch) => {
    dispatch({ type: types.FLOW_CMI_SET_LOADING, payload: true });
    try {
      const body = await fetchFlowCmiCasesRequest(filters);
      if (body.ok) {
        dispatch({
          type: types.FLOW_CMI_SET_CASES,
          payload: {
            cases: body.cases || [],
            total: body.total || 0,
            page: body.page || 0,
            size: body.size || 20,
            aggregates: body.aggregates || {
              total: body.total || 0,
              published: 0,
              inTray: 0,
              traysWithLoad: 0,
              modulesWithResults: 0,
              usersWithCases: 0,
              pending: 0
            }
          }
        });
      } else {
        handleError(body, dispatch);
      }
    } finally {
      dispatch({ type: types.FLOW_CMI_SET_LOADING, payload: false });
    }
  };
};

export const clearFlowCmiDetail = () => ({
  type: types.FLOW_CMI_CLEAR_DETAIL
});

export const startLoadingFlowCmiCase = (moduleId, referenceId) => {
  return async (dispatch) => {
    const resp = await fetchToken(const_routes.SCHEMA, const_routes.VERSIONV1, const_routes.ROUTE_FLOW_CMI, `case/${moduleId}/${referenceId}`);
    const body = await resp.json();
    if (body.ok) {
      dispatch({ type: types.FLOW_CMI_SET_DETAIL, payload: { record: body.record, timeline: body.timeline } });
      return body;
    }
    handleError(body, dispatch);
    return null;
  };
};
